import { Box, styled } from '@/shared/ui';

export const PaymentItemContainer = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: '100%',
  textAlign: 'center',
  padding: '22px 18px',
}));
